var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.recommendations.length > 0 ? 'recommender-main' : ''},[_c('recommendations',{attrs:{"recommendations":_vm.recommendations},on:{"click":_vm.addRecommendation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }